// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2oH_n","section-title":"_1xViC","features-wrapper":"_1g5nO","feature":"Plkit","odd":"_1jsFE","even":"_3mEoV","alt":"_3WDbI","text-wrapper":"_2cLLM"};